module.exports = __webpack_public_path__ + "static/media/psd-icon.8aa12904.svg";